import  * as React from 'react'
// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';
//const: muss definiert werden unter "export default"
const ForbioLignoBio  = () => {
    const {t} = useI18next();
    return (
        <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
          <div className='row'>

            <div className='col-12'>
              <div className='container'>
                <BoxInfo description={t('text')} />
              </div>
            </div>
          </div>
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
                {/* Übersicht */}            
                <h1 align="left"> {t('title1')} </h1>
                <p> {t('text11')} </p>
                <p> {t('text12')} </p>
                <p> {t('text13')} </p>
                <p> {t('text14')} </p>
                {/* Forbio */}
                <h1 align="left"> {t('title2')} </h1>
                <p> {t('text21')} </p>
                {/* CA 66344 */} 
                <h3 align="left"> {t('subtitle21')} </h3>
                <p> {t('text211')} </p>
                <p> {t('text212')} </p>
                <p> {t('text213')} </p>
                {/* CA 66344 Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: &ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&ensp;&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t3')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&ensp;&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert21')}</td>
                    <td>{t('tabw1t3-wert21')}</td>
                    <td>{t('tabw1t4-wert21')}</td>
                    <td>{t('tabw1t5-wert21')}</td>
                    <td>{t('tabw1t10-wert21')}</td>
                  </tr>
                </table></div>
                </div>
                {/* Forbio BP6930 */} 
                <h3 align="left"> {t('subtitle22')} </h3>
                <p> {t('text221')} </p>
                <p> {t('text222')} </p>
                <p> {t('text223')} </p>
                {/* BP6930 Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: & ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t2')} <br/>&#91;g/10min&#93;<br/>190/2,16</th>
                    <th>{t('tabw1t3')} <br/>&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&#91;KJ/m&sup2;&#93;</th>
                    <th>{t('tabw1t11')} <br/>&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert22')}</td>
                    <td>{t('tabw1t2-wert22')}</td>
                    <td>{t('tabw1t3-wert22')}</td>
                    <td>{t('tabw1t4-wert22')}</td>
                    <td>{t('tabw1t5-wert22')}</td>
                    <td>{t('tabw1t10-wert22')}</td>
                    <td>{t('tabw1t11-wert22')}</td>
 {/*                <td>allemeine&shy;entchenschwimmen&shy;aufdemsee</td> */}
                  </tr>
                </table></div>
                </div>
                {/* Forbio Rec */} 
                <h1 align="left"> {t('title3')} </h1>
                <p> {t('text31')} </p>
                {/* Forbio PB 1151 rpla mit Holzmehl */} 
                <h3 align="left"> {t('subtitle31')} </h3>
                <p> {t('text311')} </p>
                <p> {t('text312')} </p>
                <p> {t('text313')} </p>
                
                {/* Wertetabelle */}
                <div className='row'>
                  <div></div>
                  <div className='col-8'>
                    <table>
                  <tr>
                    {/* leerzeichen: & ensp;[: &#91; / &sup3 : hochgest. 3 / ]: &#93;  */}
                    <th>{t('tabw1t1')} <br/>&ensp;&#91;g/cm&sup3;&#93;</th>
                    <th>{t('tabw1t2')}<br/>&#91;g/10min&#93;<br/>&ensp;190/2,16</th>
                    <th>{t('tabw1t3')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t4')} <br/>&ensp;&#91;MPa&#93;</th>
                    <th>{t('tabw1t5')} <br/>&ensp;&#91;%&#93;</th>
                    <th>{t('tabw1t10')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                    <th>{t('tabw1t11')} <br/>&ensp;&#91;KJ/m&sup2;&#93;</th>
                  </tr>
                  <tr>
                    <td>{t('tabw1t1-wert31')}</td>
                    <td>{t('tabw1t2-wert31')}</td>
                    <td>{t('tabw1t3-wert31')}</td>
                    <td>{t('tabw1t4-wert31')}</td>
                    <td>{t('tabw1t5-wert31')}</td>
                    <td>{t('tabw1t10-wert31')}</td>
                    <td>{t('tabw1t11-wert31')}</td>
                  </tr>
                </table></div>
                </div>
      {/* weitere Typen */} 
                <h2 align="left"> {t('title10')} </h2>
                <p> {t('text101')} </p>  


            
                {/*<p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bil d" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>

    );
};

export default ForbioLignoBio

// Fuer Search engine  optimizationjj
export const Head = () =>( <Seo title="Produktentwicklung" keywords="Produktentwicklung Biopolymere" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
export const query = graphql`
query ($language: String!) {
  locales: allLocale(
    filter: { ns: { in: ["forbioligno"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;